var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-card", { attrs: { bordered: false } }, [
    _c(
      "div",
      {
        staticStyle: {
          width: "100%",
          height: "100%",
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
          gap: "0.5rem",
          "flex-direction": "column"
        }
      },
      [
        _c("div", { staticStyle: { "font-size": "2em" } }, [
          _vm._v("歡迎進入職福會選禮平台！")
        ]),
        _c("div", { staticStyle: { "font-size": "1.5em" } }, [
          _vm._v("您可以透過左側功能列進行活動相關資訊的維護與設定。")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }